<iframe
  *ngIf="sanitizedResource"
  [src]="sanitizedResource"
  width="100%"
  height="100%"
></iframe>
